import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    GET_REPORTES,
    SET_USER_FUNCTIONS_REPORTS,
    GET_REPORTES_RESULT,
    INITIAL_STATE_REPORTS
} from '../../Screens/InvocadorReportes/actions/Actions';

const initialState = {
    isFetching: false,
    functions: [],
    reportes: [],
    nombre: ""
}

export default function invocadorReportes(state = initialState, action) {
    LogHelper.In(invocadorReportes.name, state, action);

    switch (action.type) {
        case GET_REPORTES:
            return { ...state, isFetching: true };

        case SET_USER_FUNCTIONS_REPORTS:
            return { ...state, functions: action.functions };

        case GET_REPORTES_RESULT:
            return { ...state, isFetching: false, reportes: action.data };

        case INITIAL_STATE_REPORTS:
            return initialState;
            break;

        default:
            LogHelper.Out(invocadorReportes.name);
            return state;
    }
    
    return state;
}


// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/InvocadorReportes.js